import React from 'react';

import PageSite from '../../components/Communication/PageSite/PageSite.module';

const PageSiteView = () => {
  return <PageSite />;
};

export default PageSiteView; 